// extracted by mini-css-extract-plugin
export default {"role-table__action":"Role_role-table__action__u9C5Y"};